import AppDispatcher from '../dispatcher/AppDispatcher';
import EgainConstants from '../constants/EgainConstants';

class EgainActionCreator {
  getSamlToken() {
    AppDispatcher.handleViewAction({
      actionType: EgainConstants.GET_SAML_TOKEN,
    });
  }

  getSamlTokenSuccess(samlToken) {
    AppDispatcher.handleServerAction({
      actionType: EgainConstants.GET_SAML_TOKEN_SUCCESS,
      samlToken,
    });
  }
}

export default new EgainActionCreator();
